module.exports = __webpack_public_path__ + "media/images/emoticons/denim-b68166d2f41a949090866235c7694b2b.gif";